import React from 'react';
import PatientsTable from './containers/PatientsTable.jsx';

function App() {
  return (
    <div style={{ marginLeft: '2px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6, marginLeft: 6 }}>
        <img
          src="https://www.dentiscribe.com/wp-content/uploads/2023/10/ICON-dentiscribe-150x150.png"
          alt="DentiScribe"
          width={32}
          height={32}
          style={{ display: 'block', borderRadius: 6 }}
        />
        <h1 style={{ margin: 0 }}>DentiSet</h1>
      </div>

      <PatientsTable />
    </div>
  );
}

export default App;
